import { stimulusApp } from './application.js'
import ScaConsentCallbackController from './sca_consent_callback_controller.js'
import GtmEventController from './gtm_event_controller.js'
import SmartInvestAnnouncementController from './smart_invest_announcement_controller'

// Register controllers
stimulusApp.register('gtm-event', GtmEventController);
stimulusApp.register('sca-consent-callback', ScaConsentCallbackController);
stimulusApp.register('smart-invest-announcement', SmartInvestAnnouncementController);
